<template>
    <div class="needPayContainer">
        <van-nav-bar
                title="待支付订单"
                left-arrow
                :fixed='true'
                @click-left="onClickBack"
            />
        <div class="needPayInfo" v-if="orderInfo">
            <van-panel :title="orderInfo.createTime"  status="待支付">
                <van-cell-group>
                    <van-field  v-model="orderInfo.oCode" label="订单号" readonly />
                    <van-field  v-model="orderInfo.custName" label="客户名称" readonly />
                    <van-field  v-model="orderInfo.phonenum" label="手机号" readonly />
                    <van-field  v-model="orderInfo.pName" label="套餐包" readonly />
                    <van-field  v-model="orderInfo.backMoney" label="返还金额" readonly />
                    <van-field  v-model="orderInfo.backMonth" label="返还月份" readonly />
                    <van-field  v-model="orderInfo.rechareMoney" label="开户预存" readonly />
                    <van-field  v-model="orderInfo.payMoney" label="需付款" readonly />
                </van-cell-group>
            </van-panel>
            <div class="needPayInfo-warning">
                友情提示:需付款金额 = 返还金额 * 返还月份 + 开户预存
            </div>
            <div class='needPayInfo-btn'>
                <van-button type="primary" size="large" @click="toPay" :loading='submitLoading' loading-text='正在提交...'>确认支付</van-button>
            </div>
        </div>
    </div>
    
</template>

<script>
  import {setAesString,getAesString} from "../../config/date";
  import {isWeiXin} from '../../common/functionUtil';

export default {
    name: 'needPayInfo',
    data(){
        return{
            platform:'weixin',
            submitLoading:false,
            orderInfo:{
                oCode:'HJ157847148604332',
                custName:'测试',
                pName:'电信标准套餐199元5G(合约)套餐',
                phonenum:'17090335353',
                baseMoney:'199元',
                backMoney:'99元',
                backMonth:'24月',
                rechareMoney:'200元',
                payMoney:'2576元',
                createTime:'2020-01-08 16:20:22',
                payMoneyDesc:'99 * 24 + 200',

            }
        }
    },
    created(){
        this.orderInfo = sessionStorage.getItem(setAesString("orderInfo"));
        if(this.orderInfo == null){
            this.$dialog.alert({
                message: '支付信息获取失败,返回上一步重新操作!'
            }).then(() => {
                //提交数据
               
            });
            return;
        }
        this.orderInfo = JSON.parse(getAesString(this.orderInfo));
        this.orderInfo.baseMoney = this.orderInfo.baseMoney+" 元";
        this.orderInfo.backMoney = this.orderInfo.backMoney+" 元";
        this.orderInfo.backMonth = this.orderInfo.backMonth+" 月";
        this.orderInfo.rechareMoney = this.orderInfo.rechareMoney+" 元";
        this.orderInfo.payMoney = this.orderInfo.payMoney+" 元";
    },
    mounted() {
        if(this.isWeiXin()){
            this.platform = "weixin";
        }else{
            this.platform = "other";             
        }
    },
    methods: {
        isWeiXin,
        onClickBack() {
            this.$router.back(-1);//返回上一层
        },
        toPay(){
            if(this.orderInfo == null){
                this.$dialog.alert({
                    message: '订单信息不存在,返回上一步重新操作!'
                }).then(() => {
                    this.$router.back(-1);//返回上一层
                });
                return;
            }
            var formdata = {
                service:'user.5gPay',
                orderCode:this.orderInfo.oCode,
                platform:this.platform,
                successUrl:this.$api.locationUrl+'/ctc5g/f365f52eb',
            }

            this.submitLoading = true;
            this.$api.post("/mstx/pr/gateway.do", formdata,(res)=>{
                this.submitLoading = false;
                window.location.href=res;
            },(res)=>{
                this.submitLoading = false;
                this.$toast.fail(res.errorMsg);
            });
        }
    }
}
</script>

<style lang="less">
@main-blue: #20A0FF;
@main-white: #ffffff;

.needPayInfo{
    height: 100%;
    padding: 10px;
    border-radius: 50px;
    margin-top: 47px;
    &-data{
        margin-top: 50px;
        background-color:@main-white;
        padding: 20px;
        margin-bottom: 10px;
    }

    &-btn{
        text-align: center;
        margin-top: 50px 10px
    }
    &-warning{
        color:red;
        text-align:center;
        font-size:12px;
        margin: 10px 10px;
    }
}




</style>
